"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Styled = _interopRequireWildcard(require("./styles/IframeWrapper.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IframeWrapper = function IframeWrapper(_ref) {
  var url = _ref.url,
      title = _ref.title,
      id = _ref.id,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'bodyOffset' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$allow = _ref.allow,
      allow = _ref$allow === void 0 ? [] : _ref$allow;
  var isAutoResizeHeight = height === 'lowestElement' || height === 'bodyOffset';
  var iframeProps = {
    src: url,
    title: title,
    id: id,
    width: width,
    height: isAutoResizeHeight ? 'auto' : height,
    heightCalculationMethod: height === 'lowestElement' ? height : 'bodyOffset',
    sizeHeight: isAutoResizeHeight,
    allow: allow.join(';')
  };
  return /*#__PURE__*/_react["default"].createElement(Styled.Iframe, iframeProps);
};

IframeWrapper.displayName = "IframeWrapper";
var _default = IframeWrapper;
exports["default"] = _default;
//# sourceMappingURL=IframeWrapper.js.map